import { TableFilter } from '../types';

export const queryParamKeys = {
  endDateTime: 'endDateTime',
  experimentId: 'experimentId',
  page: 'page',
  pageSize: 'pageSize',
  search: 'search',
  selectedTab: 'selectedTab',
  startDateTime: 'startDateTime',
  [TableFilter.EXPERIMENT_MODIFIED_BY]: TableFilter.EXPERIMENT_MODIFIED_BY,
  [TableFilter.EXPERIMENT_TEST_SUBJECTS]: TableFilter.EXPERIMENT_TEST_SUBJECTS,
  [TableFilter.EXPERIMENT_SYSTEM_WINNING_CRITERIA]: TableFilter.EXPERIMENT_SYSTEM_WINNING_CRITERIA,
  [TableFilter.EXPERIMENT_CUSTOM_WINNING_CRITERIA]: TableFilter.EXPERIMENT_CUSTOM_WINNING_CRITERIA,
  [TableFilter.EXPERIMENT_WINNER_SELECTED]: TableFilter.EXPERIMENT_WINNER_SELECTED,
  [TableFilter.EXPERIMENT_SPLIT_VARIATIONS_RANDOMLY]:
    TableFilter.EXPERIMENT_SPLIT_VARIATIONS_RANDOMLY,
  [TableFilter.CAMPAIGN_TYPE]: TableFilter.CAMPAIGN_TYPE,
  [TableFilter.CAMPAIGN_MEDIUM]: TableFilter.CAMPAIGN_MEDIUM,
  [TableFilter.CAMPAIGN_LABELS]: TableFilter.CAMPAIGN_LABELS,
  selectedMetrics: 'selectedMetrics',
  sortBy: 'sortBy',
  sortDirection: 'sortDirection',
  tab: 'tab',
  timeZone: 'timeZone',
};
